var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 78,
    viewBox: "0 0 160 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0037 22.1627C66.4706 3.74538 48.0787 -0.265388 40.5744 0.0313914C27.7282 -0.604524 0.127623 8.29878 0.000432145 37.9343C-0.126759 67.5699 27.8553 77.3636 40.8288 77.2364C53.8023 77.1093 66.3943 73.6751 81.53 54.7236C94.2492 72.5304 111.929 77.1093 120.069 77.1093C128.209 77.1093 159.244 74.0567 159.371 38.1887C159.498 2.32079 126.81 0.158542 119.56 0.158542C112.31 0.158542 90.815 3.84709 80.0037 22.1627ZM40.5746 14.6556C56.8551 14.5538 69.0655 29.537 73.1356 37.0413C70.7613 45.5631 61.1033 62.5812 41.465 62.4795C16.917 62.3523 14.7548 43.528 14.7548 37.2956C14.7548 31.0632 20.224 14.7828 40.5746 14.6556ZM88.9077 37.8007C91.7059 30.1268 101.779 14.8045 119.688 14.9063C142.074 15.0335 145.126 31.9499 145.253 37.8007C145.381 43.6515 143.091 61.9671 120.578 62.0942C102.568 62.196 91.9603 45.941 88.9077 37.8007Z",
    fill: "url(#paint0_linear_266_18490)",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_266_18490",
    x1: 78.5,
    y1: -2,
    x2: 81,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C46DC",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoader);
export default __webpack_public_path__ + "static/media/logo-loader.1d05563047cdefef7f7bae0be4902482.svg";
export { ForwardRef as ReactComponent };